/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Application_Submitted_LabelInputs */

const en_candidate_application_submitted_label = /** @type {(inputs: Candidate_Application_Submitted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application submitted:`)
};

const de_candidate_application_submitted_label = /** @type {(inputs: Candidate_Application_Submitted_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbung eingereicht:`)
};

/**
* | output |
* | --- |
* | "Application submitted:" |
*
* @param {Candidate_Application_Submitted_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_application_submitted_label = /** @type {((inputs?: Candidate_Application_Submitted_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Application_Submitted_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_application_submitted_label(inputs)
	return en_candidate_application_submitted_label(inputs)
});